<mwe-wizard [wizardModel]="wizardModel()" #wizard>
  <router-outlet (activate)="wizard.onActivate($event, wizardModel())" />
</mwe-wizard>
